import { render, staticRenderFns } from "./QueueAvgTimeChart.vue?vue&type=template&id=1f6ae574&scoped=true"
import script from "./QueueAvgTimeChart.vue?vue&type=script&lang=js"
export * from "./QueueAvgTimeChart.vue?vue&type=script&lang=js"
import style0 from "./QueueAvgTimeChart.vue?vue&type=style&index=0&id=1f6ae574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ae574",
  null
  
)

export default component.exports